import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import common from 'src/js/modules/common/';

const { Box, ActionButton, ColorSelector, ToggleSection, Divider, SliderPattern, Stack } =
  designSystem;
const {
  components: { ModalWithPanels, MediaPreview },
} = common;

const MODAL_WIDTH = 336;
const MODAL_HEIGHT = 552;

const TextDecorationSettingsDialog = ({
  decorationSettings,
  decorationPreviewUrl,
  dialogPosition = null,
  captions,
  elementForPositioning,
  onDecorationChange,
  onSubmit,
  onCancel,
  onPositioningReady,
  onOverlayClick,
  onDialogDragEnd,
}) => (
  <ModalWithPanels
    width={MODAL_WIDTH}
    height={MODAL_HEIGHT}
    offsetX={dialogPosition?.x}
    offsetY={dialogPosition?.y}
    captions={captions}
    withHorizontalPadding={false}
    elementForPositioning={elementForPositioning}
    onSubmit={onSubmit}
    onCancel={onCancel}
    onPositioningReady={onPositioningReady}
    onOverlayClick={onOverlayClick}
    onDragEnd={onDialogDragEnd}
    onPressEsc={onCancel}
  >
    <div className="ws-text-decoration-settings">
      <Box paddingLeft="spacing-m" paddingRight="spacing-m">
        <MediaPreview url={decorationPreviewUrl} size="auto" />
      </Box>
      <Box
        marginTop="spacing-xs"
        marginBottom="spacing-s"
        paddingLeft="spacing-m"
        paddingRight="spacing-m"
      >
        <ActionButton label={captions.changeDecorationButton} onClick={onDecorationChange} />
      </Box>
      {decorationSettings.map((setting) => (
        <Fragment key={setting.sectionProps.title}>
          <Divider />
          <Box
            paddingTop="spacing-xs"
            paddingBottom="spacing-xs"
            paddingRight="spacing-m"
            paddingLeft="spacing-m"
          >
            <ToggleSection {...setting.sectionProps}>
              <Stack gap="spacing-2-xs">
                {setting.controls.map((controlProps) => (
                  <React.Fragment>
                    {controlProps.type === 'color-selector' && <ColorSelector {...controlProps} />}
                    {controlProps.type === 'slider' && <SliderPattern {...controlProps} />}
                  </React.Fragment>
                ))}
              </Stack>
            </ToggleSection>
          </Box>
        </Fragment>
      ))}
    </div>
  </ModalWithPanels>
);

TextDecorationSettingsDialog.propTypes = {
  decorationPreviewUrl: PropTypes.string.isRequired,
  decorationSettings: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  dialogPosition: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }),
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    submitButton: PropTypes.string.isRequired,
    cancelButton: PropTypes.string.isRequired,
    changeDecorationButton: PropTypes.string.isRequired,
  }).isRequired,
  elementForPositioning: PropTypes.oneOfType([PropTypes.shape(), PropTypes.node]).isRequired,
  onDecorationChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onPositioningReady: PropTypes.func.isRequired,
  onOverlayClick: PropTypes.func.isRequired,
  onDialogDragEnd: PropTypes.func.isRequired,
};

export default TextDecorationSettingsDialog;
